import { useUIStore } from '@/config/stores/ui-store';
import { useNotificationStore } from '@/core/notification/notification-store';
import { useAuthStore } from '@/features/auth/stores/auth.store';
import { ExitToApp, Menu } from '@mui/icons-material';
import NotificationsActiveRoundedIcon from '@mui/icons-material/NotificationsActiveRounded';
import NotificationsOffRoundedIcon from '@mui/icons-material/NotificationsOffRounded';
import { Box, IconButton, Stack, Typography } from '@mui/material';

interface DrawerHeaderProps {
  open: boolean;
  isMobile: boolean;
}

export default function DrawerHeader({ open, isMobile }: DrawerHeaderProps) {
  const shouldShowTitle = open && (isMobile || !isMobile);

  const { logout } = useAuthStore();
  const { toggleSidebar } = useUIStore();
  const enabled = useNotificationStore((s) => s.enabled);
  const setEnabled = useNotificationStore((s) => s.setEnabled);

  return (
    <Box
      sx={{
        display: 'flex',
        minHeight: 64,
        alignItems: 'center',
        borderBottom: 1,
        borderColor: 'divider',
        justifyContent: open ? 'flex-start' : 'center',
        px: open ? 2 : 1,
        '@media (min-width: 900px)': {
          justifyContent: 'flex-start',
          px: 2
        }
      }}
    >
      <Stack direction='row' alignItems='center' justifyContent={open ? 'space-between' : 'center'} flex={1}>
        {shouldShowTitle && (
          <Typography
            variant='h4'
            noWrap
            color='text.primary'
            sx={{
              px: 1,
              display: isMobile ? 'block' : { xs: 'none', sm: 'block' }
            }}
          >
            Tin nhắn
          </Typography>
        )}
        <Stack direction='row' alignItems='center' justifyContent='center' gap={1}>
          {open && (
            <IconButton size='small' onClick={() => setEnabled(!enabled)} aria-label='toggle notification'>
              {enabled ? (
                <NotificationsActiveRoundedIcon fontSize='small' />
              ) : (
                <NotificationsOffRoundedIcon fontSize='small' />
              )}
            </IconButton>
          )}
          {open && import.meta.env.MODE !== 'production' && (
            <IconButton
              onClick={() => {
                logout();
              }}
            >
              <ExitToApp />
            </IconButton>
          )}
          {!isMobile && (
            <IconButton onClick={toggleSidebar}>
              <Menu />
            </IconButton>
          )}
        </Stack>
      </Stack>
    </Box>
  );
}
